import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import React from 'react';
import { useIntl } from 'react-intl';

import { TextType, Text } from 'ui-components/components/text';
import { FlexRow } from 'ui-components/components/flex';
import { Button } from 'ui-components/components/button';

import { useHomePageOnboardContext } from '../../home-page-onboard-context';
import { OnboardingStepsComponents } from '../../constants';

import style from './onboard-cards.module.less';
import { messages } from './messages';

export const OnboardCards = () => {
  const intl = useIntl();
  const { svgToRender, totalCompletedSteps, totalSteps, isOnboardingComplete, dismissOnboarding, onboardingSteps } =
    useHomePageOnboardContext();
  const altText = intl.formatMessage(messages.percentComplete, {
    totalCompletedSteps,
    totalSteps,
  });
  return (
    <div className={style['onboard-container']}>
      <div className={style['onboard-column']}>
        <Text className={style['home-page-title']} textType={TextType.H1} value={messages.homePageTitle} />
        <div className={style['onboard-cards-header']}>
          <Text textType={TextType.H3} value={messages.onboardTitle} />
          <FlexRow className={style['percent-container']}>
            <img alt={altText} className={style['onboard-svg']} src={svgToRender} />
            <Text
              formattedMessageValues={{
                totalCompletedSteps,
                totalSteps,
              }}
              textType={TextType.Paragraph}
              value={messages.percentComplete}
            />
            {isOnboardingComplete && (
              <FlexRow className={style['button-and-divider']}>
                <div className={style.divider} />
                <Button className={style['close-button']} onClick={dismissOnboarding} theme='unstyled'>
                  <FontAwesomeIcon className={style['x-mark']} icon={faXmark} />
                </Button>
              </FlexRow>
            )}
          </FlexRow>
        </div>
        <div className={style['onboard-cards']}>
          {onboardingSteps.map((step) => {
            const Step = OnboardingStepsComponents[step];
            return <Step key={step} />;
          })}
        </div>
      </div>
    </div>
  );
};
